(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["card-grid"] && !Shopify.designMode) return;
  try {
    
function initializeCardGridHoverIcons(container = document) {
  const scope =
    container.querySelectorAll === undefined ? document : container;

  scope.querySelectorAll('.card-grid-wrapper .card').forEach((card) => {
    if (card.dataset.cardGridInitialized === 'true') return;

    const icon = card.querySelector('.card-icon');

    if (!icon?.dataset.hoverSrc) return;

    card.dataset.cardGridInitialized = 'true';

    const showHover = () => {
      icon.src = icon.dataset.hoverSrc;
    };

    const showDefault = () => {
      icon.src = icon.dataset.defaultSrc;
    };

    card.addEventListener('mouseenter', showHover);
    card.addEventListener('mouseleave', showDefault);
    card.addEventListener('focusin', showHover);
    card.addEventListener('focusout', showDefault);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    initializeCardGridHoverIcons();
  });
} else {
  initializeCardGridHoverIcons();
}

document.addEventListener('shopify:section:load', (event) => {
  initializeCardGridHoverIcons(event.target);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customer-unboxing"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const sectionId = '{{ section.id }}';
    const cards    = document.querySelectorAll('#videos-' + sectionId + ' .card[data-src]');
    const modal    = document.getElementById('videoModal-' + sectionId);
    const iframe   = document.getElementById('modalIframe-' + sectionId);
    const title    = document.getElementById('modalTitle-' + sectionId);
    const closeBtn = document.getElementById('modalClose-' + sectionId);

    function openModal(src, name) {
      iframe.src = src + '?autoplay=1&rel=0';
      title.innerHTML = name;
      modal.classList.add('active');
      document.body.style.overflow = 'hidden';
    }

    function closeModal() {
      modal.classList.remove('active');
      iframe.src = '';
      document.body.style.overflow = '';
    }

    cards.forEach(function(card) {
      card.addEventListener('click', function() {
        openModal(card.dataset.src, card.dataset.name);
      });
    });

    closeBtn.addEventListener('click', closeModal);
    modal.addEventListener('click', function(e) {
      if (e.target === modal) closeModal();
    });
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') closeModal();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-card"] && !Shopify.designMode) return;
  try {
    
function initializeFaqAccordions(container = document) {
  container.querySelectorAll('[data-faq-accordion]').forEach((accordion) => {
    if (accordion.dataset.initialized === 'true') return;

    accordion.dataset.initialized = 'true';

    accordion.addEventListener(
      'toggle',
      (event) => {
        const activeItem = event.target;

        if (
          activeItem.tagName !== 'DETAILS' ||
          !activeItem.open ||
          activeItem.parentElement !== accordion
        ) {
          return;
        }

        accordion.querySelectorAll('.faq-item[open]').forEach((item) => {
          if (item !== activeItem) {
            item.removeAttribute('open');
          }
        });
      },
      true
    );
  });
}

document.addEventListener('DOMContentLoaded', () => {
  initializeFaqAccordions();
});

document.addEventListener('shopify:section:load', (event) => {
  initializeFaqAccordions(event.target);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faqs"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    // Tab switching
    const tabs = document.querySelectorAll('.faq-tabs .tab');
    const contents = document.querySelectorAll('.faq-contents .content');

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        const target = tab.dataset.tab;
        tabs.forEach((t) => t.classList.remove('active'));
        tab.classList.add('active');
        contents.forEach((c) => c.classList.remove('active'));
        document.querySelector('.faq-contents .' + target).classList.add('active');
      });
    });

    // Accordion: only one open at a time, toggle on click
    document.addEventListener('click', function (e) {
      // Check if clicked element or its parent is the accordion button
      const question = e.target.closest('.accordion-question');
      
      if (question) {
        const currentItem = question.closest('.accordion-item');
        const accordion = currentItem.parentElement;

        const isActive = question.classList.contains('active');

        // close all in this accordion
        accordion.querySelectorAll('.accordion-question').forEach((btn) => {
          btn.classList.remove('active');
          btn.nextElementSibling.style.maxHeight = null;
        });

        // if it was not active, open it
        if (!isActive) {
          question.classList.add('active');
          const answer = question.nextElementSibling;
          answer.style.maxHeight = answer.scrollHeight + 'px';
        }
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-banner"] && !Shopify.designMode) return;
  try {
    
/*
 * Full-banner click. When "Open referral signup form" is enabled and the link
 * is still the "#" placeholder, the overlay anchor opens the ReferRush signup
 * form (window.openReferRushSignupForm, defined by the app's contact-form.js).
 * A real URL always navigates normally. Delegated from document, bound once, so
 * it survives shopify:section:load re-renders.
 */
if (!window.duroflexReferRushBannerBound) {
  window.duroflexReferRushBannerBound = true;

  document.addEventListener('click', (event) => {
    const node = event.target instanceof Element ? event.target : null;
    if (!node) return;

    const trigger = node.closest('a.banner-link[data-referrush-trigger]');
    if (!trigger) return;

    const href = trigger.getAttribute('href') || '';
    if (href !== '' && href !== '#') return;

    event.preventDefault();
    if (typeof window.openReferRushSignupForm === 'function') {
      window.openReferRushSignupForm();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-slider-animation"] && !Shopify.designMode) return;
  try {
    
class ImageCenterSlider {
  constructor(slider) {
    this.slider = slider;
    this.track = slider.querySelector('.image-slider-track');

    if (!this.track) return;

    this.originalSlides = Array.from(
      this.track.querySelectorAll('.image-item')
    );

    this.totalSlides = this.originalSlides.length;
    this.cloneCount = Math.min(3, this.totalSlides);
    this.currentIndex = this.cloneCount;

    this.autoplayEnabled =
      slider.dataset.autoplay === 'true';

    this.autoplaySpeed =
      Number.parseInt(slider.dataset.speed, 10) || 3000;

    this.autoplayTimer = null;
    this.resizeTimer = null;
    this.transitionTimer = null;

    this.isTransitioning = false;
    this.isDragging = false;
    this.didDrag = false;
    this.isHovered = false;

    this.startX = 0;
    this.currentX = 0;
    this.dragDistance = 0;
    this.startTranslate = 0;
    this.activePointerId = null;

    if (!this.totalSlides) return;

    if (this.totalSlides === 1) {
      this.originalSlides[0].classList.add('is-active');
      this.originalSlides[0].setAttribute(
        'aria-hidden',
        'false'
      );

      this.slider.classList.add('is-ready');
      return;
    }

    this.initialize();
  }

  async initialize() {
    this.createClones();
    this.refreshSlides();

    /*
     * Wait until original and cloned images are loaded.
     */
    await this.preloadImages();

    this.bindEvents();

    requestAnimationFrame(() => {
      this.goToSlide(this.currentIndex, false);

      requestAnimationFrame(() => {
        this.slider.classList.add('is-ready');
        this.startAutoplay();
      });
    });
  }

  createClones() {
    const beforeFragment =
      document.createDocumentFragment();

    const afterFragment =
      document.createDocumentFragment();

    for (
      let index = 0;
      index < this.cloneCount;
      index += 1
    ) {
      const beforeIndex =
        (
          this.totalSlides -
          this.cloneCount +
          index +
          this.totalSlides
        ) % this.totalSlides;

      const afterIndex =
        index % this.totalSlides;

      const beforeClone =
        this.originalSlides[beforeIndex].cloneNode(true);

      const afterClone =
        this.originalSlides[afterIndex].cloneNode(true);

      this.prepareClone(beforeClone);
      this.prepareClone(afterClone);

      beforeFragment.appendChild(beforeClone);
      afterFragment.appendChild(afterClone);
    }

    this.track.prepend(beforeFragment);
    this.track.append(afterFragment);
  }

  prepareClone(clone) {
    clone.classList.add('is-clone');
    clone.removeAttribute('data-shopify-editor-block');

    clone.querySelectorAll('[id]').forEach((element) => {
      element.removeAttribute('id');
    });

    clone
      .querySelectorAll('img.media-image')
      .forEach((image) => {
        image.loading = 'eager';
        image.decoding = 'async';
      });
  }

  refreshSlides() {
    this.slides = Array.from(
      this.track.querySelectorAll('.image-item')
    );
  }

  preloadImages() {
    const images = Array.from(
      this.track.querySelectorAll('img.media-image')
    );

    return Promise.all(
      images.map((image) => {
        image.loading = 'eager';

        return new Promise((resolve) => {
          const finish = () => {
            if (typeof image.decode === 'function') {
              image
                .decode()
                .catch(() => {})
                .finally(resolve);
            } else {
              resolve();
            }
          };

          if (
            image.complete &&
            image.naturalWidth > 0
          ) {
            finish();
            return;
          }

          image.addEventListener('load', finish, {
            once: true
          });

          image.addEventListener('error', resolve, {
            once: true
          });
        });
      })
    );
  }

  getSlideWidth() {
    return (
      this.slides[0]?.getBoundingClientRect().width || 0
    );
  }

  getTranslateValue(index) {
    const viewportWidth = this.slider.clientWidth;
    const slideWidth = this.getSlideWidth();

    return -(
      index * slideWidth -
      (viewportWidth - slideWidth) / 2
    );
  }

  setTrackPosition(translateX, animate = true) {
    this.track.style.transition = animate
      ? 'transform 0.5s ease'
      : 'none';

    this.track.style.transform =
      `translate3d(${translateX}px, 0, 0)`;
  }

  goToSlide(index, animate = true) {
    if (!this.slides.length) return;

    this.currentIndex = index;
    this.isTransitioning = animate;

    this.setTrackPosition(
      this.getTranslateValue(index),
      animate
    );

    this.updateActiveSlide();

    window.clearTimeout(this.transitionTimer);

    if (animate) {
      this.transitionTimer = window.setTimeout(() => {
        this.handleLoopReset();
      }, 550);
    }
  }

  updateActiveSlide() {
    this.slides.forEach((slide, index) => {
      const isActive =
        index === this.currentIndex;

      slide.classList.toggle('is-active', isActive);

      slide.setAttribute(
        'aria-hidden',
        isActive ? 'false' : 'true'
      );
    });
  }

  showNext() {
    if (
      this.isTransitioning ||
      this.isDragging
    ) {
      return;
    }

    this.goToSlide(
      this.currentIndex + 1,
      true
    );
  }

  showPrevious() {
    if (
      this.isTransitioning ||
      this.isDragging
    ) {
      return;
    }

    this.goToSlide(
      this.currentIndex - 1,
      true
    );
  }

  handleTransitionEnd(event) {
    if (
      event.target !== this.track ||
      event.propertyName !== 'transform'
    ) {
      return;
    }

    this.handleLoopReset();
  }

  handleLoopReset() {
    if (!this.isTransitioning) return;

    window.clearTimeout(this.transitionTimer);

    this.isTransitioning = false;

    const firstOriginalIndex =
      this.cloneCount;

    const afterLastOriginalIndex =
      this.cloneCount + this.totalSlides;

    if (
      this.currentIndex >=
      afterLastOriginalIndex
    ) {
      const offset =
        this.currentIndex -
        afterLastOriginalIndex;

      this.jumpToSlide(
        firstOriginalIndex + offset
      );

      return;
    }

    if (
      this.currentIndex <
      firstOriginalIndex
    ) {
      const offset =
        firstOriginalIndex -
        this.currentIndex;

      this.jumpToSlide(
        afterLastOriginalIndex - offset
      );
    }
  }

  jumpToSlide(index) {
    this.slider.classList.add(
      'is-loop-resetting'
    );

    this.currentIndex = index;

    this.setTrackPosition(
      this.getTranslateValue(index),
      false
    );

    this.updateActiveSlide();

    void this.track.offsetWidth;

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        this.slider.classList.remove(
          'is-loop-resetting'
        );
      });
    });
  }

  startAutoplay() {
    if (
      !this.autoplayEnabled ||
      this.totalSlides <= 1 ||
      this.isDragging ||
      this.isHovered ||
      document.hidden
    ) {
      return;
    }

    this.stopAutoplay();

    this.autoplayTimer = window.setInterval(() => {
      this.showNext();
    }, this.autoplaySpeed);
  }

  stopAutoplay() {
    if (!this.autoplayTimer) return;

    window.clearInterval(this.autoplayTimer);
    this.autoplayTimer = null;
  }

  handlePointerDown(event) {
    if (
      this.isTransitioning ||
      this.isDragging ||
      event.button > 0
    ) {
      return;
    }

    this.isDragging = true;
    this.didDrag = false;
    this.activePointerId = event.pointerId;

    this.startX = event.clientX;
    this.currentX = event.clientX;
    this.dragDistance = 0;

    this.startTranslate =
      this.getTranslateValue(this.currentIndex);

    this.stopAutoplay();

    this.slider.classList.add('is-dragging');
    this.track.style.transition = 'none';

    this.slider.setPointerCapture?.(
      this.activePointerId
    );
  }

  handlePointerMove(event) {
    if (
      !this.isDragging ||
      event.pointerId !== this.activePointerId
    ) {
      return;
    }

    this.currentX = event.clientX;

    this.dragDistance =
      this.currentX - this.startX;

    if (Math.abs(this.dragDistance) > 5) {
      this.didDrag = true;
    }

    this.setTrackPosition(
      this.startTranslate + this.dragDistance,
      false
    );
  }

  handlePointerUp(event) {
    if (
      !this.isDragging ||
      event.pointerId !== this.activePointerId
    ) {
      return;
    }

    this.finishDrag(false);
  }

  handlePointerCancel(event) {
    if (
      !this.isDragging ||
      event.pointerId !== this.activePointerId
    ) {
      return;
    }

    this.finishDrag(true);
  }

  finishDrag(cancelled = false) {
    const pointerId = this.activePointerId;

    this.isDragging = false;
    this.slider.classList.remove('is-dragging');

    if (
      pointerId !== null &&
      this.slider.hasPointerCapture?.(pointerId)
    ) {
      this.slider.releasePointerCapture(pointerId);
    }

    const slideWidth = this.getSlideWidth();

    const swipeThreshold = Math.min(
      Math.max(slideWidth * 0.18, 35),
      80
    );

    if (
      !cancelled &&
      Math.abs(this.dragDistance) >= swipeThreshold
    ) {
      if (this.dragDistance > 0) {
        this.goToSlide(
          this.currentIndex - 1,
          true
        );
      } else {
        this.goToSlide(
          this.currentIndex + 1,
          true
        );
      }
    } else {
      this.goToSlide(
        this.currentIndex,
        true
      );
    }

    this.startX = 0;
    this.currentX = 0;
    this.dragDistance = 0;
    this.startTranslate = 0;
    this.activePointerId = null;

    window.setTimeout(() => {
      this.didDrag = false;
    }, 50);

    this.startAutoplay();
  }

  handleClick(event) {
    if (!this.didDrag) return;

    event.preventDefault();
    event.stopPropagation();
  }

  handleResize() {
    window.clearTimeout(this.resizeTimer);

    this.resizeTimer = window.setTimeout(() => {
      if (this.isDragging) return;

      this.goToSlide(
        this.currentIndex,
        false
      );
    }, 150);
  }

  bindEvents() {
    this.track.addEventListener(
      'transitionend',
      (event) => {
        this.handleTransitionEnd(event);
      }
    );

    this.slider.addEventListener(
      'pointerdown',
      (event) => {
        this.handlePointerDown(event);
      }
    );

    this.slider.addEventListener(
      'pointermove',
      (event) => {
        this.handlePointerMove(event);
      }
    );

    this.slider.addEventListener(
      'pointerup',
      (event) => {
        this.handlePointerUp(event);
      }
    );

    this.slider.addEventListener(
      'pointercancel',
      (event) => {
        this.handlePointerCancel(event);
      }
    );

    this.slider.addEventListener(
      'click',
      (event) => {
        this.handleClick(event);
      },
      true
    );

    this.slider.addEventListener(
      'dragstart',
      (event) => {
        event.preventDefault();
      }
    );

    this.slider.addEventListener(
      'mouseenter',
      () => {
        this.isHovered = true;
        this.stopAutoplay();
      }
    );

    this.slider.addEventListener(
      'mouseleave',
      () => {
        this.isHovered = false;

        if (!this.isDragging) {
          this.startAutoplay();
        }
      }
    );

    window.addEventListener(
      'resize',
      () => {
        this.handleResize();
      }
    );

    document.addEventListener(
      'visibilitychange',
      () => {
        if (document.hidden) {
          this.stopAutoplay();
        } else {
          this.startAutoplay();
        }
      }
    );
  }
}

function initializeImageSliders(container = document) {
  const sliders = container.matches?.(
    '[data-image-slider]'
  )
    ? [container]
    : container.querySelectorAll(
        '[data-image-slider]'
      );

  sliders.forEach((slider) => {
    if (
      slider.dataset.sliderInitialized === 'true'
    ) {
      return;
    }

    slider.dataset.sliderInitialized = 'true';

    new ImageCenterSlider(slider);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener(
    'DOMContentLoaded',
    () => {
      initializeImageSliders();
    }
  );
} else {
  initializeImageSliders();
}

document.addEventListener(
  'shopify:section:load',
  (event) => {
    initializeImageSliders(event.target);
  }
);

/*
 * ReferRush signup trigger.
 *
 * Mirrors the contract of templates/page.referals.liquid: any
 * .referrush-refer-btn / .cta-btn click opens the ReferRush signup form
 * when the app embed has loaded. Delegated from document so it survives
 * shopify:section:load re-renders, scoped to .image-slider-sec so it can
 * never hijack the airboost .cta-btn buttons, and bound exactly once.
 */
if (!window.duroflexReferRushSliderBound) {
  window.duroflexReferRushSliderBound = true;

  document.addEventListener('click', (event) => {
    const node =
      event.target instanceof Element ? event.target : null;

    if (!node) return;

    const trigger = node.closest(
      '.image-slider-sec .referrush-refer-btn, .image-slider-sec .cta-btn'
    );

    if (!trigger) return;

    /*
     * "Button link" is a normal url setting on a generic, presettable
     * section, so a merchant who sets a real URL must get a working link.
     * The referral hijack therefore applies only while the link is still
     * the "#" placeholder, which is what the Refer & Earn page ships with.
     */
    const href = trigger.getAttribute('href') || '';

    if (href !== '' && href !== '#') return;

    if (typeof window.openReferRushSignupForm === 'function') {
      event.preventDefault();
      window.openReferRushSignupForm();
      return;
    }

    /*
     * The original page used <button>, so a click did nothing when the
     * app had not loaded. These are anchors, so swallow the placeholder
     * click rather than letting it jump to the top of the page.
     */
    event.preventDefault();
  });
}

  } catch(e) { console.error(e); }
})();
})();
